if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
                        constructor() {
    super();

    this.form = this.querySelector('form');
    this.form.querySelector('[name=id]').disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    if (submitButton.classList.contains('loading')) return;

    this.handleErrorMessage();
    this.cartNotification.setActiveElement(document.activeElement);

    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }
      if((response.product_type == "Jackets") || (response.product_type == "Legacy") || (response.product_type == "Raincoats") || (response.product_type == "Outerwear")){
        var myStringArray = ["31794552307825","39610736967793"];
        var arrayLength = myStringArray.length;
        for (var i = 0; i < arrayLength; i++) {
          var qty =1;
          var data = {
            id: myStringArray[i],
            quantity: qty
          };

          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data,
            cache: false,
            async: false,
            success: function(){

            }
          });
          //Do something
        }

        //               Shopify.addItem("31105110343750", 1,function(line_item2){
        // //             this.cartNotification.renderContents(line_item);

        //           });
        //           Shopify.addItem('32098893561926', 1, function(line_item){
        // //             this.cartNotification.renderContents(line_item);
        //           });

      }
      jQuery.getJSON(window.Shopify.routes.root + 'products/'+response.handle+'.js', function(product) {
        console.log('Here');
        console.log(product);
        $.each( product.tags, function( key, value ) {
          if (value.indexOf("product_") >= 0){
            var colorsList="";
            var sizeList='<option value="">- Select Size -</option>';
            var tagss=value.split('product_');
            jQuery.getJSON(window.Shopify.routes.root + 'products/'+tagss[1]+'.js', function(addOnProduct) {
              console.log(addOnProduct);
              var variants=addOnProduct.variants;
//               console.log("variants here");
//               console.log(variants);
             
              var options='<span class="select-label">Select Colour</span>';
              console.log("Colors");
              $.each(addOnProduct.options,function(t,e){
                if(e.name == "Color"){
                  $.each(e.values,function(index,value){
                    var img=$('.option_image[data-color="'+value.toLowerCase()+'"]').val();
                    colorsList+='<li class="color_product_upsell yes tooltip '+(index==0?"active":"")+'" data-productid="'+addOnProduct.id+'"  data-color="'+value+'"><div class="color-name" ><img src="'+img+'"></div></li>';
                  });
                }
              });
              $.each(addOnProduct.options,function(t,e){
                if(e.name == "Size"){
                  $.each(e.values,function(index,value){
                    sizeList+='<option value="'+value+'"'+(0==index?"selected":"")+'">'+value+'</option>';
                  });
                }
                });
              var priceAddOn=parseFloat(addOnProduct.price / 100).toFixed(2);
              $('.ao__collection').css("display","none");
                    $('.add_on--product-section').html(`<div class="heading"><h2>Did you see this?</h2></div><div class="add_on-product-main"><div class="add-on-product-content"><div class="ao-img-text">
                    <div class="ao-product-image"><img src="`+addOnProduct.featured_image+`"></div>
                    <div class="ao__detail">
                    <a href="`+addOnProduct.url+`"><h3 class="cart-notification-product__name h4">`+addOnProduct.title+`</h3></a>
                    <div class="ao__price">$`+priceAddOn+` CAD</div>
              		<ul class="ao-color-list">`+colorsList+`</ul>
              		<select class="size_options size_options_upsell" data-productid="`+addOnProduct.id+`">`+sizeList+`
                      <input type=hidden class="main-input" value="`+addOnProduct.variants[0].id+`"></ul>
                    </div></div>
                     <button type="submit" name="add" class="product-form__submit addOn-submit button button--full-width button--primary">Add to Cart</button>
                    </div></div>`);
              $.each(variants,function(index,variant){
                var variant_loop = variant.id;
                var variant_title = variant.title;
                $('.ao__detail').append('<input type=hidden value="'+variant_loop+'" data-title="'+variant_title+'">');
                
              });
            });
          }else{
//           	$('.ao__collection').css("display","block");
          }
        });
      } );
      
      this.cartNotification.renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
             console.log('here');
    submitButton.classList.remove('loading');
    submitButton.removeAttribute('aria-disabled');
    this.querySelector('.loading-overlay__spinner').classList.add('hidden');
  });
}

handleErrorMessage(errorMessage = false) {
  this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
  this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

  this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

  if (errorMessage) {
    this.errorMessage.textContent = errorMessage;
  }
}
});
}
$(document).on('click','.color_product_upsell',function(){
  $('.color_product_upsell').removeClass('active');
  $(this).addClass('active');
  var color=$(this).data('color');
  var size=$('.size_options_upsell').val();
  var select_title = color+' / '+size;
  var selected_variant = $('input[data-title="'+select_title+'"]').val();
  $(".main-input").val(selected_variant);
});
$(document).on('change','.size_options_upsell',function(){
  var color=$('.color_product_upsell.active').data('color');
  var size=$(this).val();
  var select_title = color+' / '+size;
  var selected_variant = $('input[data-title="'+select_title+'"]').val();
  $(".main-input").val(selected_variant);
});

$(document).on('click','.addOn-submit',function(){
  var qty =1;
  var input_value = $(".main-input").val();
  $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
              id:input_value,
              quantity:qty
            },
            cache: false,
            async: false,
            success: function(){
              window.location = "https://nobis.com/cart";
            }
          });
  });

